import PropTypes from "prop-types";
import styles from "./index.css";
import { decodeAndSortUrl } from "../../helpers/decodeAndSortUrl";

const range = (start, end) =>
  Array(end - start + 1)
    .fill()
    .map((value, index) => start + index);

const Pagination = ({
  formatTranslation,
  shouldRender,
  currentPage,
  maxPage,
  url,
  countryCode
}) => {
  if (!shouldRender) {
    return null;
  }

  const MAX_LINKS = countryCode === "DK" ? 20 : 50;

  const start = Math.max(1, currentPage - MAX_LINKS / 2);
  const end = Math.min(maxPage, currentPage + MAX_LINKS / 2);

  const adjustedStart = Math.max(2, end - MAX_LINKS);
  const adjustedEnd = Math.min(maxPage, start + MAX_LINKS);

  let pages = [];
  if (maxPage > 1) {
    pages = range(adjustedStart, adjustedEnd).filter(
      page => page !== currentPage
    );
    if (currentPage !== 1) {
      pages = [1, ...pages];
    }
  }

  return (
    <div className={styles.paginationLinks} data-nosnippet>
      {pages.map(page => (
        <a
          key={page}
          href={decodeAndSortUrl(`${url}${page === 1 ? "" : `&page=${page}`}`)}
        >
          {`${formatTranslation("plp_web_category_page")} ${page}`}
        </a>
      ))}
    </div>
  );
};

Pagination.propTypes = {
  formatTranslation: PropTypes.func.isRequired,
  shouldRender: PropTypes.bool.isRequired,
  currentPage: PropTypes.number.isRequired,
  maxPage: PropTypes.number.isRequired,
  url: PropTypes.string.isRequired,
  countryCode: PropTypes.string.isRequired
};

export default Pagination;
